// extracted by mini-css-extract-plugin
export default {"root":"toggle_checkbox_item-module___root___ffcaf9ff"};